export const enum ClaimSetSections {
  AllClaimSets = 'AllClaimSets',
  GlobalSearchClaimSets = 'GlobalSearchClaimSets',
}
